import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Auth} from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private auth: Auth, private router: Router) {
    }

    canActivate() {
        if (this.auth.isLoggedIn()) {
            return true;
        } else {
            const next = this.router['location'].path();
            this.router.navigate(['/belepes'], {queryParams: {n: next}});
            return false;
        }
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/auth-guard.service.ts